import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { Box, NoSsr, Text, Tooltip } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { breakpoints, colors } from '@99designs/emu/settings';
import ParneterImage from './Partner';

export default function OurPartners() {
    const partners = [
        {
            hoverText:
                'Complex reports on cultural movements and trends. Their celebrity committee hand-picked and provided fresh creative direction for five diverse small businesses.',
            learnMoreLink: 'https://www.complex.com',
            image: {
                url: '99daysofdesign/partners/Complex.jpg',
                alt: '',
            },
        },
        {
            hoverText:
                'A media company championing young women, Refinery29 nominated eleven independent, female-owned businesses to receive creative and financial support.',
            learnMoreLink: 'https://www.refinery29.com',
            image: {
                url: '99daysofdesign/partners/Refinery29.jpg',
                alt: '',
            },
        },
        {
            hoverText:
                'Huck celebrates independence, seeking out the artists, activists and creative pioneers who are challenging mainstream culture.',
            learnMoreLink: 'https://www.huckmag.com',
            image: {
                url: '99daysofdesign/partners/huck.jpg',
                alt: '',
            },
        },
        {
            hoverText:
                'A podcast created to help BIPOC creatives find their dream careers, Claima selected and supported twelve BIPOC small business owners and helped tell their stories.',
            learnMoreLink: 'https://www.claimastories.com',
            image: {
                url: '99daysofdesign/partners/Claima_Stories.jpg',
                alt: '',
            },
        },
        {
            hoverText:
                'This leading lifestyle and gaming brand put forward three up-and-coming streamers from its community for a visual refresh.',
            learnMoreLink: 'https://100thieves.com',
            image: {
                url: '99daysofdesign/partners/100theves.jpg',
                alt: '',
            },
        },
    ];

    const isMobile = useMediaQuery({ maxWidth: breakpoints.medium[1] });

    return (
        <Box>
            <Box display="flex" alignItems="center">
                <Line />
                <Box paddingX="2bu" flexShrink={0}>
                    <Text fontFamily="heading" size="size5" lineHeight="small">
                        Our partners
                    </Text>
                </Box>
                <Line />
            </Box>
            <Box display="flex" flexWrap="wrap">
                {partners.map((partner) => (
                    <NoSsr key={partner.image.url}>
                        {isMobile ? (
                            <PartnerImageContainer paddingX={['0.25bu', '0.75bu', '1.5bu', '2bu']}>
                                <ParneterImage partner={partner} />
                            </PartnerImageContainer>
                        ) : (
                            <Tooltip title={<TooltipText>{partner.hoverText}</TooltipText>}>
                                <PartnerImageContainer
                                    paddingX={['0.25bu', '0.75bu', '1.5bu', '2bu']}
                                >
                                    <ParneterImage partner={partner} />
                                </PartnerImageContainer>
                            </Tooltip>
                        )}
                    </NoSsr>
                ))}
            </Box>
        </Box>
    );
}

const Line = styled.div`
    height: 2px;
    width: 100%;
    background-color: ${colors.grey300};
`;

const TooltipText = styled.div`
    display: block;
    text-align: center;
`;

const PartnerImageContainer = styled(Box)`
    width: 20%;

    ${mediaQuery.only('small')} {
        width: 50%;
        &:last-child {
            margin: 0 auto;
            width: 50%;
        }
    }
`;
